import templateUrl from './publishingAtAGlancePending.html';
import './publishingAtAGlancePending.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-pending');

class PublishingAtAGlancePendingController {
	constructor($rootScope, $scope, $timeout, publishingService, x1UiTabsConstants) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.publishingService = publishingService;
		this.x1UiTabsConstants = x1UiTabsConstants;
		this.entries = [];
		this.message = 'There are no pending publishing events.';  // normal visible message when no entries
		this.srmessage = '';  // used by screen reader
		
		this.$onInit = () => {
			this.fetchPendingPublishingJobs();
		}
        
		// listen for the event to apply new preferences
		const handler = $rootScope.$on('apply-preferences', (event, payload) => {
			this.fetchPendingPublishingJobs();
		});
		$scope.$on('$destroy', handler);

		// listen for x1 tab selection events
		const handler2 = $rootScope.$on(this.x1UiTabsConstants.EVENTS.selectComplete, (event, data) => {
			if (data.tabId === 'pendingTab') {
				
				// get Jaws to read the message when there are no entries
	        	if (this.entries && this.entries.length === 0) {
	        		this.message = 'There are no pending publishing events.';
	        		
	        		this.$timeout(() => {
		        		this.srmessage = 'There are no pending publishing events.';
	        		}, 1500);
	        	}
			}
			else {
				this.srmessage = '';
			}
		});
		$scope.$on('$destroy', handler2);
	}
	
	fetchPendingPublishingJobs() {
        this.publishingService.getCurrentPending().then(
    		(data) =>  {
	        	this.entries = data;
	        	this.$scope.$apply();
    		},
    		(error) =>  {
	        	this.entries = [];
	        	this.srmessage = 'searchError';
	        	this.message = 'searchError';
    		}
		);
	}
}

export default {
	controller: [ '$rootScope', '$scope', '$timeout', 'publishingService', 'x1.ui.tabs.constant', PublishingAtAGlancePendingController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlancePending/publishingAtAGlancePending.component.js